import * as React from 'react';
import { memo } from 'react';

const SvgCurrencyCircleDollar = (props) => (React.createElement("svg", Object.assign({ width: "1em", height: "1em", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M10 5.625v1.25M10 13.125v1.25", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }),
    React.createElement("path", { d: "M10 17.5a7.5 7.5 0 1 0 0-15 7.5 7.5 0 0 0 0 15Z", stroke: "currentColor", strokeWidth: 1.25, strokeLinecap: "round", strokeLinejoin: "round" }),
    React.createElement("path", { d: "M8.125 13.125h2.813a1.563 1.563 0 0 0 0-3.125H9.062a1.562 1.562 0 1 1 0-3.125h2.813", stroke: "currentColor", strokeWidth: 1.25, strokeLinecap: "round", strokeLinejoin: "round" })));
const Memo = memo(SvgCurrencyCircleDollar);

export { Memo as default };
